import React from 'react'
import PropTypes from 'prop-types'
/**
 * @summary Hash
 * @component
 *
 * @param {object} props
 *
 * @returns {node} jsx markup
 */
function Hash({ styling }) {
  return (
    <svg
      className={styling}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 100 100"
      stroke="currentColor"
    >
      <title>Hash</title>
      <path d="M84.086 38.313c3.637 0 6.597-2.958 6.602-6.597 0-3.642-2.963-6.607-6.602-6.607h-7.91l1.725-8.291a6.573 6.573 0 00-.944-4.964 6.562 6.562 0 00-4.177-2.843 6.729 6.729 0 00-1.349-.139c-3.106 0-5.822 2.209-6.461 5.257l-2.284 10.98-14.674.005 1.742-8.387a6.555 6.555 0 00-.94-4.966 6.565 6.565 0 00-4.177-2.843 6.54 6.54 0 00-1.351-.142c-3.109 0-5.825 2.212-6.458 5.258l-2.303 11.079H20.823c-3.637 0-6.598 2.96-6.598 6.602 0 3.637 2.963 6.597 6.603 6.597h10.949L27.37 59.507H15.91c-3.637 0-6.598 2.96-6.598 6.602 0 3.637 2.962 6.598 6.602 6.598h8.711l-2.183 10.479c-.739 3.56 1.557 7.063 5.122 7.807.443.091.897.139 1.348.139a6.627 6.627 0 006.46-5.256l2.737-13.168h14.678l-2.2 10.574a6.564 6.564 0 00.942 4.961 6.56 6.56 0 004.18 2.844c.444.093.896.139 1.346.139a6.628 6.628 0 006.463-5.256l2.756-13.262h12.897c3.638 0 6.598-2.959 6.602-6.598 0-3.642-2.962-6.607-6.602-6.607H69.022l4.406-21.188h10.658zm-24.147 0l-4.404 21.188-14.678.006 4.407-21.194h14.675z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
Hash.propTypes = {
  styling: string,
}

export default Hash
